import { z } from "zod";

export const tableSpecSchema = z.object({
	// This data is just a passthrough version of the docsapi expectation.
	// We don't want to update this if we expand the permissions set somehow.
	permissions: z.array(z.any()),
});

export type TableSpec = z.infer<typeof tableSpecSchema>;
